import { v4 as uuidv4 } from "uuid";

export const trackViewItem = (
  value: number,
  itemId: string,
  itemBrand?: string
) => {
  window.dataLayer?.push({
    event: "view_item",
    currency: "USD",
    value,
    items: [
      {
        item_id: itemId,
        item_name: itemId,
        item_brand: itemBrand,
        price: value,
        quantity: 1,
      },
    ],
  });
};

export const trackBeginCheckout = (
  value: number,
  itemId: string,
  kind: string,
  extras: Record<string, unknown> = {}
) => {
  window.dataLayer?.push({
    event: `begin_checkout_${kind}`,
    currency: "USD",
    value: Number(value.toFixed(2)),
    items: [
      {
        item_id: itemId,
        item_name: itemId,
        price: value,
        quantity: 1,
      },
    ],
    ...extras,
  });
};

export const trackPurchase = (
  value: number,
  itemId: string,
  kind: string,
  extras: Record<string, unknown> = {}
) => {
  window.dataLayer?.push({
    event: `purchase_${kind}`,
    currency: "USD",
    value: Number(value.toFixed(2)),
    transaction_id: uuidv4(),
    items: [
      {
        item_id: itemId,
        item_name: itemId,
        price: value,
        quantity: 1,
      },
    ],
    ...extras,
  });
};

export const trackEvent = (
  eventName: string,
  extras: Record<string, unknown> = {}
) => {
  window.dataLayer?.push({
    event: eventName,
    ...extras,
  });
};
